import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Please confirm")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6" }
const _hoisted_5 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_6 = { class: "d-flex flex-stack flex-grow-1 " }
const _hoisted_7 = { class: " fw-bold" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h4", { class: "text-gray-800 fw-bolder" }, "Network Setup confirmation", -1)
const _hoisted_9 = { class: "fs-6 text-gray-600 " }
const _hoisted_10 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" as your Sponsor and you will be placed on the ")
const _hoisted_12 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" below your upline ")
const _hoisted_14 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_15 = {
  key: 0,
  class: "pt-5"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Your original requested upline is ")
const _hoisted_17 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "pt-5" }, " Please click Submit to Proceed ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.formdata.responsedata.fullname) + ", you are requesting to register a new account with ", 1),
              _createVNode("a", _hoisted_10, _toDisplayString(_ctx.formdata.responsedata.sponsorname) + " (" + _toDisplayString(_ctx.formdata.spid) + ")", 1),
              _hoisted_11,
              _createVNode("a", _hoisted_12, _toDisplayString(_ctx.formdata.position == 'L' ? 'Left' : 'Right'), 1),
              _hoisted_13,
              _createVNode("a", _hoisted_14, _toDisplayString(_ctx.formdata.responsedata.uplinename) + " (" + _toDisplayString(_ctx.formdata.responsedata.actualuplineid) + ") ", 1),
              (_ctx.formdata.uplineid !=  _ctx.formdata.responsedata.actualuplineid)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode("a", _hoisted_17, _toDisplayString(_ctx.formdata.responsedata.requesteduplinename) + " (" + _toDisplayString(_ctx.formdata.upid) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_18
            ])
          ])
        ])
      ])
    ])
  ]))
}